import { createFileRoute } from "@tanstack/react-router";

import { ConnectorsPage } from "@/components/paid-media/connectors/connectors-page";

export const Route = createFileRoute("/dashboard/paid-media/_layout/connectors")({
  component: ConnectorsPage,
});
